// @flow
import React from 'react';
import { Box, Typography, makeStyles, Link, Dialog, Button } from '@material-ui/core';
import { SyncAlt as SyncAltIcon } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  content: {
    padding: '30px 20px',
    textAlign: 'center',
    '& h3': {
      color: '#0069FF'
    },
    '& p': {
      maxWidth: 350,
      margin: '0 auto'
    }
  },
  cancelBtn: {
    color: 'var(--colorDefault)',
    textDecoration: 'underline'
  },
  deleteBtn: {
    backgroundColor: '#0069FF !important',
    color: '#fff !important'
  },
  deleteIcon: {
    backgroundColor: 'rgba(25, 148, 230, 0.2)',
    color: '#0069FF',
    borderRadius: '50%',
    padding: '15px',
    fontSize: '40px'
  }
}));

const OverridePinnedPostModal = ({ open, close, onConfirm }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} fullWidth>
      <div className={classes.content}>
        <Box pb={2.5}>
          <SyncAltIcon className={classes.deleteIcon} />
        </Box>
        <Typography variant="h3" display="block" gutterBottom>
          Override?
        </Typography>
        <Box pb={2.5} pt={1.5}>
          <Typography display="block" gutterBottom>
            A post is currently pinned, are you sure you want to override the current pinned post?
          </Typography>
        </Box>
        <Box pb={2.5}>
          <Button variant="contained" className={classes.deleteBtn} onClick={onConfirm}>
            Yes, I want to override
          </Button>
        </Box>
        <Box>
          <Link
            className={classes.cancelBtn}
            href="#"
            onClick={e => {
              e.preventDefault();
              close();
            }}
            color="inherit"
          >
            Cancel
          </Link>
        </Box>
      </div>
    </Dialog>
  );
};

export default OverridePinnedPostModal;
